import React from 'react';
import { motion } from 'framer-motion';
import TopNavbarre from '../composants/topnavbarre';
import Footer from '../composants/footer';
import { FaUserGraduate, FaFileAlt, FaHandsHelping, FaSearchDollar, FaHome, FaBriefcase } from "react-icons/fa";
import header from '../asset/1.png';
import { Link } from "react-router-dom";

const Service = () => {
  const handleScroll = (e) => {
    e.preventDefault();
    const nextSection = document.getElementById('content');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    {
      title: "Orientation personnalisée",
      description: "Évaluation complète du profil pour proposer les meilleures opportunités d'études.",
      icon: <FaUserGraduate className="text-3xl" />,
      color: "bg-blue-100 text-blue-600"
    },
    {
      title: "Assistance administrative",
      description: "Aide pour les démarches : pré-inscription, visa, assurance, etc.",
      icon: <FaFileAlt className="text-3xl" />,
      color: "bg-purple-100 text-purple-600"
    },
    {
      title: "Soutien continu",
      description: "Suivi après admission, accompagnement à l'intégration et soutien moral.",
      icon: <FaHandsHelping className="text-3xl" />,
      color: "bg-green-100 text-green-600"
    },
    {
      title: "Aide financière attestation de virement irrévocable",
      description: "Aide pour rechercher des bourses ou solutions de financement.",
      icon: <FaSearchDollar className="text-3xl" />,
      color: "bg-orange-100 text-orange-600"
    },
    {
      title: "Hébergement",
      description: "Assistance pour trouver un logement étudiant confortable et abordable.",
      icon: <FaHome className="text-3xl" />,
      color: "bg-red-100 text-red-600"
    },
    {
      title: "Job étudiant",
      description: "Conseils pour trouver un petit emploi compatible avec les études.",
      icon: <FaBriefcase className="text-3xl" />,
      color: "bg-indigo-100 text-indigo-600"
    },
    {
      title: "Accueil et intégration",
      description: "Organisation de l'accueil à l'arrivée et aide à l'intégration dans le nouvel environnement.",
      icon: <FaHandsHelping className="text-3xl" />,
      color: "bg-yellow-100 text-yellow-600"
    }

  ];

  // Animation variants
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <div>
      <section className="relative bg-cover bg-center h-screen flex flex-col">
        {/* Image de fond avec overlay */}
        <div 
          className="absolute inset-0 bg-black/30 bg-blend-darken"
          style={{
            backgroundImage: `url(${header})`,
            backgroundPosition: 'center 30%',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>
        
        {/* Navbar */}
        <TopNavbarre/>
        
        {/* Contenu principal centré verticalement */}
        <div className="relative z-10 flex-grow flex items-center justify-center text-center">
          <div className="mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl lg:max-w-4xl">
              {/* Titre principal avec animation */}
              <motion.h1 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="text-2xl sm:text-2xl md:text-2xl lg:text-3xl font-bold text-white leading-tight mb-2 sm:mb-4"
              >
                Nos services vous guide vers<span className="text-blue-400"> la réussite</span>
              </motion.h1>
              
              {/* Sous-titre */}
              <motion.p 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.8 }}
                className="text-base sm:text-lg md:text-xl text-gray-100 mb-6 sm:mb-8 max-w-lg"
              >
                De l’orientation à l’hébergement, découvrez tout ce que nous faisons pour vous accompagner efficacement.
              </motion.p>
              
              {/* Groupe de boutons */}
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.8 }}
                className="flex flex-col sm:flex-row gap-3 sm:gap-4"
              >
                <a
                  href="#services"
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold 
                            px-4 py-2 sm:px-6 sm:py-2.5 md:px-8 md:py-3 
                            rounded-lg shadow-lg transition-all duration-300 
                            transform hover:-translate-y-1 text-sm sm:text-base mx-auto block text-center"
                  onClick={(e) => {
                    e.preventDefault();
                    const servicesSection = document.getElementById('services');
                    if (servicesSection) {
                      servicesSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  Découvrir nos services
                </a>
              </motion.div>
            </div>
          </div>
        </div>
        
        {/* Indicateur de défilement */}
        <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <motion.a 
            href="#services" 
            className="animate-bounce inline-block"
            onClick={handleScroll}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </motion.a>
        </div>
      </section>

      {/* Section Services */}
      <section id="services" className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <span className="inline-block bg-blue-400/20 text-blue-300 px-4 py-2 rounded-full text-sm font-medium mb-4">
              Notre expertise
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Nos <span className="text-blue-300">Services</span>
            </h2>
            <p className="text-lg text-blue-100 max-w-3xl mx-auto">
              Un accompagnement complet pour concrétiser votre projet d'études à l'international.
            </p>
          </motion.div>

          {/* Services */}
          <motion.div 
            initial="hidden"
            whileInView="show"
            variants={container}
            viewport={{ once: true, margin: "-100px" }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {services.map((service, index) => (
              <motion.div 
                key={index} 
                variants={item}
                whileHover={{ y: -10 }}
                className="group"
              >
                <div className="h-full bg-white/10 backdrop-blur-sm rounded-xl shadow-sm border border-white/20 overflow-hidden group-hover:shadow-md group-hover:border-blue-400/30 transition-all duration-300">
                  <div className="p-8 flex flex-col h-full">
                    <div className={`${service.color} w-16 h-16 rounded-xl flex items-center justify-center mb-6`}>
                      {service.icon}
                    </div>
                    <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
                    <p className="text-blue-100 mb-6 flex-grow">{service.description}</p>
                    <div className="w-10 h-1 bg-blue-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>

          {/* CTA Section */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            viewport={{ once: true }}
            className="mt-20 text-center"
          >
            <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-8 md:p-10 shadow-xl">
              <div className="max-w-4xl mx-auto">
                <h3 className="text-2xl font-bold text-white mb-4">Prêt à commencer votre aventure académique ?</h3>
                <p className="text-blue-100 mb-6">Nos conseillers sont disponibles pour vous accompagner.</p>
                <motion.div 
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="inline-block"
                >
                  <Link
                    to="/contact" // Redirige vers la page de contact
                    className="bg-white text-blue-900 hover:bg-blue-50 px-8 py-3 rounded-lg font-semibold shadow-md transition-all duration-300"
                  >
                    Prendre rendez-vous
                  </Link>
                </motion.div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default Service;